import { EActionState } from '@/models';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { ISendGridTemplate } from '@/models/templates';

export const templateSlice = createSlice({
	name: '@@template',
	initialState: initialState,
	reducers: {
		INIT_EMAIL_START: state => {
			state.email = {
				init: EActionState.RUNNING,
				templates: initialState.email.templates
			};
		},
		INIT_EMAIL_COMPLETED: (
			state,
			action: PayloadAction<ISendGridTemplate[]>
		) => {
			state.email = {
				init: EActionState.COMPLETED,
				templates: action.payload
			};
		},
		INIT_EMAIL_FAILED: state => {
			state.email = {
				init: EActionState.FAILED,
				templates: initialState.email.templates
			};
		},
		UPDATE_EMAIL_TEMPLATE: (
			state,
			action: PayloadAction<ISendGridTemplate>
		) => {
			const index = state.email.templates.findIndex(
				t => t.id === action.payload.id
			);
			if (index !== -1) {
				state.email.templates[index] = action.payload;
			}
		},
		SET_SOURCE_EMAIL_TEMPLATE: (
			state,
			action: PayloadAction<ISendGridTemplate | null>
		) => {
			state.sourceEmailTemplate = action.payload;
			state.targetEmailTemplateEnvironment =
				initialState.targetEmailTemplateEnvironment;
			state.targetEmailTemplate = initialState.targetEmailTemplate;
		},
		LOAD_SOURCE_EMAIL_TEMPLATE_START: state => {
			state.sourceEmailTemplateLoaded = EActionState.RUNNING;
		},
		LOAD_SOURCE_EMAIL_TEMPLATE_COMPLETED: (
			state,
			action: PayloadAction<ISendGridTemplate>
		) => {
			state.sourceEmailTemplateLoaded = EActionState.COMPLETED;
			state.sourceEmailTemplate = action.payload;
		},
		LOAD_SOURCE_EMAIL_TEMPLATE_FAILED: state => {
			state.sourceEmailTemplateLoaded = EActionState.FAILED;
		},
		LOAD_TARGET_EMAIL_TEMPLATE_START: (
			state,
			action: PayloadAction<string>
		) => {
			state.targetEmailTemplateEnvironment = action.payload;
			state.targetEmailTemplate = {
				data: initialState.targetEmailTemplate.data,
				loaded: EActionState.RUNNING
			};
			state.replicateEmailTemplateStatus =
				initialState.replicateEmailTemplateStatus;
		},
		LOAD_TARGET_EMAIL_TEMPLATE_COMPLETED: (
			state,
			action: PayloadAction<ISendGridTemplate>
		) => {
			state.targetEmailTemplate = {
				data: action.payload,
				loaded: EActionState.COMPLETED
			};
		},
		LOAD_TARGET_EMAIL_TEMPLATE_FAILED: state => {
			state.targetEmailTemplateEnvironment =
				initialState.targetEmailTemplateEnvironment;
			state.targetEmailTemplate = {
				data: initialState.targetEmailTemplate.data,
				loaded: EActionState.FAILED
			};
		},
		REPLICATE_EMAIL_TEMPLATE_START: state => {
			state.replicateEmailTemplateStatus = EActionState.RUNNING;
		},
		REPLICATE_EMAIL_TEMPLATE_COMPLETED: (
			state,
			action: PayloadAction<ISendGridTemplate>
		) => {
			state.replicateEmailTemplateStatus = EActionState.COMPLETED;
			state.targetEmailTemplate.data = action.payload;
		},
		REPLICATE_EMAIL_TEMPLATE_FAILED: state => {
			state.replicateEmailTemplateStatus = EActionState.FAILED;
		}
	}
});

export const actionCreator = templateSlice.actions;
export const reducer = templateSlice.reducer;
